import '@fontsource/Quicksand/300.css'
import '@fontsource/Quicksand/400.css'
import '@fontsource/Quicksand/500.css'
import '@fontsource/Quicksand/700.css'

export const themeOptionsLight = {
    palette: {
        mode: 'light',
        primary: {
            main: '#3d5a80',
            light: '#98c1d9',
        },
        secondary: {
            main: '#ee6c4d',
        },
        background: {
            default: '#f1eeee',
            paper: '#ffffff',
            accent: '#cfd2d4',
        },
        gray: {
            main: '#787878',
            light: '#c0c0c0',
            pale: '#e0e0e0',
            dark: '#454545',
            contrastText: '#f6f6f6',
        },
        purple: {
            main: '#9c27b0',
            dark: '#6d1b7b',
            light: '#af52bf',
            pale: '#9c27b0',
        },
        green: {
            main: '#4caf50',
            dark: '#357a38',
            light: '#4caf50',
            pale: '#6fbf73',
        },
    },
    typography: {
        fontFamily: 'Quicksand',
    },
    components: {
        MuiCollapse: {
            styleOverrides: {
                wrapper: {
                    width: '100%',
                },
                wrapperInner: {
                    width: '100%',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: '1em',
                },
            },
        },
        MuiFab: {
            styleOverrides: {
                root: {
                    color: 'white',
                    backgroundColor: '#ee6c4d',
                    '&:hover': {
                        backgroundColor: '#ee6c4d',
                    },
                },
            },
        },
        MuiSwitch: {
            styleOverrides: {
                root: {
                    width: 46,
                    height: 27,
                    padding: 0,
                    margin: 8,
                },
                switchBase: {
                    padding: 1,
                    '&$checked, &$colorPrimary$checked, &$colorSecondary$checked':
                        {
                            transform: 'translateX(16px)',
                            color: '#fff',
                            '& + $track': {
                                opacity: 1,
                                border: 'none',
                            },
                        },
                },
                thumb: {
                    width: 24,
                    height: 24,
                },
                track: {
                    borderRadius: 13,
                    border: '1px solid #bdbdbd',
                    backgroundColor: '#fafafa',
                    opacity: 1,
                    transition:
                        'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                },
            },
        },
    },
}

export const themeOptionsDark = {
    palette: {
        mode: 'dark',
        primary: {
            main: '#98C1D9',
            light: '#e0fbfc',
        },
        secondary: {
            main: '#ee6c4d',
        },
        background: {
            default: '#202020',
            paper: '#3f3f3f',
            accent: '#cfd2d4',
        },
        gray: {
            main: '#787878',
            light: '#909090',
            pale: '#505050',
            dark: '#454545',
            contrastText: '#f6f6f6',
        },
        purple: {
            main: '#9c27b0',
            dark: '#6d1b7b',
            light: '#af52bf',
            pale: '#9c27b0',
        },
        green: {
            main: '#4caf50',
            dark: '#357a38',
            light: '#4caf50',
            pale: '#6fbf73',
        },
    },
    typography: {
        fontFamily: 'Quicksand',
    },
    components: {
        MuiCollapse: {
            styleOverrides: {
                wrapper: {
                    width: '100%',
                },
                wrapperInner: {
                    width: '100%',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: '1em',
                },
            },
        },
        MuiFab: {
            styleOverrides: {
                root: {
                    color: 'white',
                    backgroundColor: '#ee6c4d',
                    '&:hover': {
                        backgroundColor: '#ee6c4d',
                    },
                },
                default: {
                    color: 'white',
                    backgroundColor: '#ee6c4d',
                    '&:hover': {
                        backgroundColor: '#ee6c4d',
                    },
                },
            },
        },
        MuiSwitch: {
            styleOverrides: {
                root: {
                    width: 46,
                    height: 27,
                    padding: 0,
                    margin: 8,
                },
                switchBase: {
                    padding: 1,
                    '&$checked, &$colorPrimary$checked, &$colorSecondary$checked':
                        {
                            transform: 'translateX(16px)',
                            color: '#fff',
                            '& + $track': {
                                opacity: 1,
                                border: 'none',
                            },
                        },
                },
                thumb: {
                    width: 24,
                    height: 24,
                },
                track: {
                    borderRadius: 13,
                    border: '1px solid #bdbdbd',
                    backgroundColor: '#fafafa',
                    opacity: 1,
                    transition:
                        'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                },
            },
        },
    },
}
